<rt-dialog-header
  [heading]="'tlc.positions.skills_ideate_flow.options.heading' | translate"
  [subheading]="'tlc.positions.skills_ideate_flow.options.subheading' | translate"
/>

<rt-dialog-body variant="white">
  <div class="content-container">
    <form class="options" [formGroup]="form">
      <div class="field">
        <rt-heading variant="heading bold" class="field-heading">
          {{ 'tlc.positions.skills_ideate_flow.options.positions.label' | translate }}
        </rt-heading>

        <rt-select2
          #positionSelect
          formControlName="positionGuids"
          [items]="positionItems()"
          withMultiselect
          withSearch
        >
          <rt-select-trigger-multi
            [extendedPreviewInOverlay]="false"
            [placeholder]="
              'tlc.positions.skills_ideate_flow.options.positions.placeholder' | translate
            "
          />
          <rt-select-header>
            {{ 'tlc.positions.skills_ideate_flow.options.positions.header' | translate }}
          </rt-select-header>
          <ng-template [rtSelectSelectedItem]="positionSelect" let-remove="remove" let-item="item">
            <rt-chips [text]="item.label" [showClose]="true" (close)="remove(item)" />
          </ng-template>
          <ng-template rtSelectSelectedItemCounter let-hiddenCount="hiddenCount">
            <rt-chips [text]="'+' + hiddenCount" [showClose]="false" />
          </ng-template>
          <ng-template
            [rtSelectListItem]="positionSelect"
            let-selectCtrl
            let-item="item"
            let-isHoverState="isHoverState"
            let-index="index"
          >
            <rt-dropdown-item
              (click)="togglePosition(item.value)"
              [class.hover]="isHoverState"
              [hasDivider]="index === 1"
            >
              <rt-checkbox
                prefix
                [checked]="isPositionChecked(item.value)"
                [hasMargin]="false"
                (valueChange)="togglePosition(item.value)"
              />
              <div class="position-option">
                <span>{{ item.label }}</span>
                <div class="member-count">
                  <rt-icon name="person" size="small-x" />
                  <span>{{
                    item.value === ALL_POSITIONS
                      ? totalMembersCount()
                      : membersCountByGuid().get(item.value)
                  }}</span>
                </div>
              </div>
            </rt-dropdown-item>
          </ng-template>
        </rt-select2>
      </div>

      <div class="field">
        <rt-heading variant="heading bold" class="field-heading">
          {{ 'tlc.positions.skills_ideate_flow.options.proficiency.label' | translate }}
        </rt-heading>
        <span class="field-description">
          {{ 'tlc.positions.skills_ideate_flow.options.proficiency.description' | translate }}
        </span>

        <rt-select2
          #levelSelect
          formControlName="proficiencyPreset"
          [items]="proficiencyPresetItems"
        >
          <rt-select-trigger />
          <ng-template
            [rtSelectListItem]="levelSelect"
            let-selectCtrl
            let-item="item"
            let-isHoverState="isHoverState"
          >
            <rt-dropdown-item
              (click)="selectCtrl.select$.next(item)"
              [class.hover]="isHoverState"
              [isSelected]="selectCtrl.itemSelector.isSelected(item)"
            >
              <div class="preset-option">
                <span class="preset-title">{{ item.label }}</span>
                <span class="preset-description">{{ presetDescription(item.value) }}</span>
              </div>
            </rt-dropdown-item>
          </ng-template>
        </rt-select2>
      </div>

      @if (isCustomPreset()) {
        <div class="field custom-levels-field">
          <rt-heading variant="heading bold" class="field-heading">
            {{ 'tlc.positions.skills_ideate_flow.options.custom_levels.label' | translate }}
          </rt-heading>
          <span class="field-description">
            {{ 'tlc.positions.skills_ideate_flow.options.custom_levels.description' | translate }}
          </span>

          <div class="custom-levels" cdkDropList (cdkDropListDropped)="reorderCustomLevels($event)">
            @for (control of customLevels.controls; track control; let i = $index) {
              <div class="custom-level-row" cdkDrag>
                <rt-icon name="drag-vertical" class="drag-handle" cdkDragHandle />
                <div class="level-badge">{{ i + 1 }}</div>
                <rt-input
                  class="level-input"
                  [formControl]="control"
                  [placeholder]="
                    'tlc.positions.skills_ideate_flow.options.custom_levels.placeholder' | translate
                  "
                />
                <rt-icon-button
                  iconName="close"
                  variant="plain"
                  [disabled]="customLevels.length <= 1"
                  (click)="removeCustomLevel(i)"
                />
              </div>
            }
          </div>

          <rt-button class="add-level-button" variant="plain" (click)="addCustomLevel()">
            <rt-icon name="add" />
            <span>{{
              'tlc.positions.skills_ideate_flow.options.custom_levels.add' | translate
            }}</span>
          </rt-button>
        </div>
      }

      <div class="field">
        <rt-heading variant="heading bold" class="field-heading">
          {{ 'tlc.positions.skills_ideate_flow.options.instructions.label' | translate }}
        </rt-heading>
        <span class="field-description">
          {{ 'tlc.positions.skills_ideate_flow.options.instructions.description' | translate }}
        </span>

        <rt-textarea
          class="instructions-textarea"
          formControlName="additionalInstructions"
          [placeholder]="
            'tlc.positions.skills_ideate_flow.options.instructions.placeholder' | translate
          "
          [charactersLimit]="maxInstructionsLength"
          [rows]="2"
          [hasCharactersLimitDivider]="true"
        />
      </div>
    </form>

    <div class="preview">
      <div class="preview-header">
        <rt-icon name="info-outline" />
        <rt-heading variant="heading bold">
          {{ 'tlc.positions.skills_ideate_flow.options.preview.heading' | translate }}
        </rt-heading>
      </div>
      <span class="preview-description">
        {{ 'tlc.positions.skills_ideate_flow.options.preview.description' | translate }}
      </span>
      <img
        class="preview-image"
        ngSrc="assets/images/tellent-skills/generate-skills-template-showcase.png"
        alt=""
        [width]="668"
        [height]="480"
      />
    </div>
  </div>
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" [disabled]="isGenerateDisabled()" (click)="generate()">
    <span>{{ 'tlc.positions.skills_ideate_flow.options.generate_file' | translate }}</span>
    <rt-icon name="arrow-forward" colorToken="colorIconOnprimaryDefault" />
  </rt-button>
</rt-dialog-footer>
